<template>
<div v-loading.fullscreen.lock="loading">
    <subHeader :title="product.title" :subtitle="product.description" :img_header="product.img_header"></subHeader>
    <div v-if="product.status" class="container py-5">
        <div class="row">
            <div class="col-lg-7 col-md-7">
                <div class="row">
                    <div class="section-heading mb-2 w-100 pl-4">
                        <h2>Inscripción</h2>
                    </div>
                    <div class="d-md-none w-100 px-3 mb-4">
                        <el-steps direction="horizontal" :active="number">
                            <el-step></el-step>
                            <el-step></el-step>
                            <el-step></el-step>
                            <el-step></el-step>
                            <!--<el-step></el-step>-->
                        </el-steps>
                    </div>
                    <div class="col-sm-2 d-none d-md-block">
                        <div style="height: 400px;" class="d-none d-md-block">
                            <el-steps direction="vertical" :active="number">
                                <el-step></el-step>
                                <el-step></el-step>
                                <el-step></el-step>
                                <el-step></el-step>
                                <!--<el-step></el-step>-->
                            </el-steps>
                        </div>
                    </div>

                    <div class="col-sm-9 card-details">
                        <wizard0 v-if="number == 0" :coverage="coverage" @getWizard0="getWizard0"></wizard0>
                        <wizard1 v-if="number == 1"
                          :product="product"
                          :seat="data_wizard0"
                          :number.sync="number"
                          :loading.sync="loading"
                          @getWizard1="getWizard1" ></wizard1>

                          <wizard2 v-if="number == 2" @getWizard2="getWizard2"></wizard2>
                    </div>

                </div>

            </div>
            <div class="col-lg-5 col-md-5">
                <div class="" v-html="product.content"></div>
            </div>
        </div>

    </div>
</div>
</template>

<script>
//components
import subHeader from "@/components/common/subHeader"
import steps from "@/components/common/Steps"
import wizard0 from "./wizard0"
import wizard1 from "./wizard1"
import wizard2 from "./wizard2"
import wizard3 from "./wizard3"

//services
import services from "@/services/services.service"
import payment from "@/services/payment.service"

export default {
    components: {
        subHeader,
        steps,
        wizard0,
        wizard1,
        wizard2,
        wizard3
    },
    data: () => ({
        loading: false,
        product: {},
        coverage: [],
        number: 0,
        data_wizard0: {},
        data_wizard1: {},
        data_wizard2: {},
        data_wizard3: {},
        order: {
            st0: null,
            st1: null,
            st2: null
        }
    }),
    methods: {
        async init(slug) {

            this.loading = true
            await services.getProductoBySlug({
                slug: slug
            }).then((res) => {
                this.product = res.data.info
                this.coverage = res.data.coverage
            }).catch((err) => {
                alert('Lo sentimos, nuestra plataforma esta presentando inconvenientes, intentalo más tarde')
                this.loading = true
            }).finally(() => {
                this.loading = false
            })
        },
        getWizard0(data) {
            this.number = 1
            this.data_wizard0 = data
        },
        getWizard1(data) {
            this.number = 2
            this.data_wizard1 = data
        },
        getWizard2(data) {
            //this.number = 2
            this.data_wizard2 = data
            this.order.st0 = this.data_wizard0
            this.order.st1 = this.data_wizard1
            this.order.st2 = this.data_wizard2
            this.sendData()
        },
         async sendData() {
            this.loading = true
            await payment.saveOrder(this.order).then((response) => {
                this.loading = false
                if (response.data.status)
                    window.location.href = response.data.url
                else
                    alert(response.data.message);
            }).catch((error) => {
                console.log(error)
                alert('Lo sentimos, nuestra plataforma esta presentando inconvenientes, intentalo más tarde')
                this.loading = false

            }).finally(() => {
                this.loading = false
            })
        }
    },
    created() {
        this.init(this.$route.path)
    }

}
</script>



// WEBPACK FOOTER //
// src/components/pages/product/Index.vue